import { controlsType, controlPositions, mapTypeStyles, mapTypes, getAdvancedSettings } from 'modules/advancedSettings';
import { getPreviewLocation } from 'modules/navigation/preview';
import { getMarkersWithForm } from 'modules/markers';
import snazzyInfoWindowOptions from 'modules/infoWindow';
import { getStyle } from 'modules/style';
import { MAX_ZOOM, MIN_ZOOM } from 'modules/location';
import { PANELS, getActivePanel } from 'modules/navigation/activePanel';

// These properties are shared between the map builder and map printings
export const getGoogleMapsProps = (state, language) => {
    const advancedSettings = getAdvancedSettings(state);
    const controlProps = (name, forceEnabled) => {
        const control = advancedSettings.controls.custom[name];
        const type = advancedSettings.controls.type;

        // Google maps will fallback to default when undefined
        let enabled;
        let position;
        let style;
        let mapTypeIds;

        if (type === controlsType.CUSTOM) {
            enabled = control.enabled;
            if (control.position) {
                position = controlPositions[control.position];
            }
            if (control.style) {
                style = mapTypeStyles[control.style];
            }
            if (control.types) {
                mapTypeIds = control.types.map((e) => mapTypes[e]);
            }
        } else if (type === controlsType.HIDE_ALL) {
            enabled = false;
        }

        if (forceEnabled === true && enabled === false) {
            enabled = true;
        }

        return {
            [`${name}Control`]: enabled,
            [`${name}ControlOptions`]: {
                position,
                style,
                mapTypeIds,
            },
        };
    };

    const behavior = advancedSettings.behavior;
    const preview = getPreviewLocation(state);
    const activePanel = getActivePanel(state);
    const forceEnableZoomPan =
        activePanel === PANELS.LOCATION || activePanel === PANELS.MARKER || activePanel === PANELS.INFO_WINDOW;
    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${key}&v=3.31&language=${language}&libraries=places,geometry`,
        language,
        center: preview.center,
        zoom: preview.zoom,
        markers: getMarkersWithForm(state).map((marker) => snazzyInfoWindowOptions(state, marker)),
        options: {
            ...controlProps('fullscreen'),
            ...controlProps('mapType'),
            ...controlProps('rotate'),
            ...controlProps('scale'),
            ...controlProps('streetView'),
            ...controlProps('zoom', forceEnableZoomPan),
            // Error when passing falsey value
            clickableIcons: !!behavior.clickableIcons && activePanel !== PANELS.MARKER,
            disableDoubleClickZoom: !behavior.doubleClickToZoom || forceEnableZoomPan,
            draggable: !!behavior.panning || forceEnableZoomPan,
            keyboardShortcuts: !!behavior.keyboardShortcuts,
            scrollwheel: !!behavior.scrollToZoom || forceEnableZoomPan,
            // TODO: Replace eval with something safer
            styles: eval(getStyle(state).json), // eslint-disable-line no-eval
            maxZoom: MAX_ZOOM,
            minZoom: MIN_ZOOM,
            mapTypeId: advancedSettings.mapType,
        },
    };
};
